import React from 'react';
import FilterBar from './Filterbar';
import Env from '../env/Env';
import { DashboardView } from '../hooks/useDashboardViews';
import useFetchFiltersData from '../hooks/fetchDataComponents/useFetchFiltersData';
import { pageHeadings, PagesCommonProps, PagesFilterOptionsByNumber } from '../helpers/pagesUtil';

type Props = {
  selectedPage: number,
  onClickLogo?: () => void,
  dashboardViews?: DashboardView[],
  filters: PagesCommonProps["filters"],
  setFilters: PagesCommonProps["setFilters"],
  filteredFilters?: PagesCommonProps["filters"],
};

const ResellerAppHeader: React.FC<Props> = ({
  filters,
  setFilters,
  onClickLogo,
  selectedPage,
  dashboardViews = [],
  filteredFilters,
}) => {
  const filtersForAPI = filteredFilters || filters;
  const { filtersData } = useFetchFiltersData({ filters: filtersForAPI });

  // Get current dashboard data
  const currentDashboard = dashboardViews[selectedPage - 1];

  // Helper function to check if a filter exists in the current dashboard
  const hasFilter = (filterName: string): boolean => {
    if (!currentDashboard?.filters) return false;
    return currentDashboard.filters.some((filter: any) => filter.name === filterName);
  };

  // Get page name from API or fallback to hardcoded
  const pageName = currentDashboard?.name || pageHeadings[selectedPage - 1];

  // Build filter options from API data
  const buildFilterOptions = () => {
    if (!currentDashboard?.filters || currentDashboard.filters.length === 0) {
      // Fallback to hardcoded filter options
      return PagesFilterOptionsByNumber(selectedPage - 1, filtersData);
    }

    // Build filter options from API data
    const filterOptions: any = {};
    currentDashboard.filters.forEach((filter: any) => {
      const filterName = filter.name;
      if (filtersData && (filtersData as any)[filterName]) {
        filterOptions[filterName] = (filtersData as any)[filterName];
      }
    });

    return filterOptions;
  };

  // Determine which filters to show based on API data
  const shouldShowDatepicker = hasFilter('datepicker');
  const shouldShowRangepicker = hasFilter('rangepicker');
  return (
    <header className="app-header-v2">
      <img onClick={onClickLogo} src={Env.LOGO_URL} alt={Env.LOGO_ALT} className="app-logo" />
      <FilterBar 
        pageName={pageName}
        {...(Env.RESELLER_PDF_NAME ? { pdfName: Env.RESELLER_PDF_NAME } : {})}
        setFilters={setFilters}
        filterOptions={buildFilterOptions()}
        hiddenDatepicker={!shouldShowDatepicker}
        hiddenRangepicker={!shouldShowRangepicker}
        filters={{...filters, lastSyncedDate: filtersData?.lastSyncedDate || ""}}
      />
    </header>
  );
}

export default ResellerAppHeader;

